import React from 'react';
import { Flex } from 'components/base/layout-components';
import BoldedValue from 'components/BoldedValue';
import Text from 'components/base/Text';
import { SIZES } from 'common/constants/sizes';

const CodeChangesCol = ({ changes, reposInfo = '', activeBranches }) => {
  const shouldRenderComponent = changes || activeBranches;
  if (!shouldRenderComponent) {
    return null;
  }
  return (
    <Flex direction='column'>
      {changes ? (
        <BoldedValue
          pb='tiny'
          value={{ size: 'large', text: changes }}
          description={{ size: 'medium', text: 'Changes' }}
        />
      ) : (
        <Text pb={SIZES.tiny} size='medium' color='shuttleGray'>
          No PRs yet
        </Text>
      )}
      {reposInfo && (
        <Text size='medium' color='shuttleGray'>
          {changes ? reposInfo : `activity ${reposInfo}`}
        </Text>
      )}
    </Flex>
  );
};

export default CodeChangesCol;
